const getErrorMessage = error => {
  if (error.message) {
    return error.message;
  }
  if (error.body) {
    if (error.body.error && typeof error.body.error === 'object' && error.body.error.message) {
      return error.body.error.message;
    }
    if (error.body.error && typeof error.body.error === 'string') {
      return error.body.error;
    }
    if (error.body.message) {
      return error.body.message;
    }
  }
  return 'Something went wrong.';
};

export default getErrorMessage;
